module.exports = __webpack_public_path__ + "static/capr-27c3f1a91fd6040685521d7cdf5d8340.png";